module.exports = "//static.hsappstatic.net/LoginUI/static-1.13962/img/google-logo.png"